import { useLoaderData, useOutletContext } from "react-router-dom";
import { PartialProduct } from "../types/PartialProduct";
import StripeProduct from "../components/Stripe/StripeProduct";
import BTCPayProduct from "../components/BTCPay/BTCPayProduct";
import { StoreData } from "../types/StoreData";
import {
  Dialog,
  DialogTrigger,
  DialogTitle,
  DialogHeader,
  DialogContent,
  DialogDescription,
  Button,
} from "@tides/base-library";
import { memo } from "react";
const Product = memo(function Product() {
  const { product } = useLoaderData() as { product: PartialProduct };
  const { shop_name } = useOutletContext<StoreData>();

  const email = product.metadata["email"] as unknown as string | undefined;

  const formattedTotal = new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: "USD",
    currencyDisplay: "narrowSymbol",
  }).format(product.price / 100);

  if (product.stock == 0) {
    return (
      <>
        <section className="mt-3 text-center">
          <article className="col-auto">
            <label className="text-center">{shop_name}</label>
          </article>

          <label className="form-label" style={{ font: "bold 20px roboto" }}>
            Sorry, this product is out of stock.
          </label>
        </section>

        <section className="text-center">
          <article className="text-muted mb-3 mt-2.5 text-sm">
            <small>
              Powered by <strong>tidus</strong>
            </small>
          </article>
        </section>
      </>
    );
  }

  return (
    <section className="bg-muted/25 border-border grid gap-x-6 rounded-md border px-4 py-4 md:grid-cols-2">
      <article className="col-span-2 w-full px-4">
        <section className="flex flex-col gap-2.5 text-center">
          <h3 className="text-foreground text-xl">
            <b>{shop_name}</b>
          </h3>
          <h2 className="text-2xl">USD {formattedTotal}</h2>
        </section>

        <StripeProduct product={product} email={email}>
          {Object.keys(product.accepted_payment_methods).map((key) => {
            if (key === "btcpay") {
              return (
                <Dialog key={key}>
                  <DialogTrigger asChild>
                    <Button className="w-full text-white" type="button">
                      <i className="bi bi-currency-bitcoin" /> Pay With{" "}
                      {product.payment_method_pretty_names[key]}
                    </Button>
                  </DialogTrigger>
                  <DialogContent className="justify-center">
                    <DialogHeader>
                      <DialogTitle className="text-foreground text-center">
                        Crypto Payment
                      </DialogTitle>
                    </DialogHeader>
                    <DialogDescription className="sr-only">
                      Crypto Payment Dialog
                    </DialogDescription>

                    <BTCPayProduct
                      price={formattedTotal}
                      accepted_crypto={
                        product.accepted_payment_methods[key].accepted_cryptos!
                      }
                      email={email}
                      product_id={product.id}
                    />
                  </DialogContent>
                </Dialog>
              );
            }
          })}
        </StripeProduct>

        <section className="text-muted-foreground mb-3 mt-2.5 text-center">
          <small>
            Powered by <strong>tidus</strong>
          </small>
        </section>
      </article>
    </section>
  );
});

export default Product;
